import { Group, Text, Pill, Flex, Tooltip } from '@mantine/core';
import { EventPreview } from '../types';
import CalendarEventStatusIcon from '@/pages/Calendar.page/Calendar.section/Calendar.event-status-icon';
import { CalendarEventStatus } from '@/pages/Calendar.page/types';
import { IconRotateClockwise } from '@tabler/icons-react';
import { CalendarEventStatusLabels } from '@/pages/Calendar.page/config';
import dayjs from 'dayjs';

export const EventItemTitle = ({
  event,
  calendarItem,
}: {
  event: EventPreview;
  calendarItem?: boolean;
}) => {
  const isPastEvent = dayjs(event.eventTime).isBefore(dayjs());
  return (
    <Flex rowGap="4" columnGap="4" align="center" wrap="wrap">
      {calendarItem && event.status && (
        <Tooltip label={CalendarEventStatusLabels[event.status]}>
          <Group align="center">
            <CalendarEventStatusIcon status={event.status} />
          </Group>
        </Tooltip>
      )}
      <Text size="sm" tt="capitalize" fw="bold">
        {event.eventType.toLowerCase()} Event{' '}
      </Text>
      <Text size="sm">
        {event.accountName && (
          <Text size="sm" span>
            <Text size="sm" span tt="lowercase">
              at
            </Text>{' '}
            {event.accountName}
          </Text>
        )}{' '}
        {event.cateringEventName && (
          <Text size="sm" span>
            ({event.cateringEventName})
          </Text>
        )}
      </Text>
      {event.status === CalendarEventStatus.COMPLETED && isPastEvent && (
        <Pill size="xs">
          <Group align="center" wrap="nowrap" c="dimmed" gap="2">
            <IconRotateClockwise size={12} />
            Event occurs in the past.
          </Group>
        </Pill>
      )}
    </Flex>
  );
};
